import { render, staticRenderFns } from "./jgbar.vue?vue&type=template&id=5f4384c3&"
import script from "./jgbar.vue?vue&type=script&lang=js&"
export * from "./jgbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports